import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { Filter } from '@pages/User/AllJobs/Filter';
import { useModalContext } from '@providers/ModalProvider';

import { Content } from './styles/Content';
import { TProps } from './types/TProps';

export const AllJobsFiltersModal = ({
  onCancel,
  jobsFilter,
  statusFilter,
  onApplyFilters,
  onSubmit,
  asOneFilter,
  postFilter,
  meetingTypeFilter,
  durationFilter,
}: TProps) => {
  const { closeModal } = useModalContext();

  return (
    <ModalWrapper width="520px" onCancel={onCancel}>
      <ModalTitle>Filters</ModalTitle>
      <Content>
        <Filter
          hideHeader
          jobsFilter={jobsFilter}
          statusFilter={statusFilter}
          onApplyFilters={onApplyFilters}
          handleSubmit={onSubmit ?? (() => undefined)}
          handleClose={closeModal}
          asOneFilter={asOneFilter}
          postFilter={postFilter}
          meetingTypeFilter={meetingTypeFilter}
          durationFilter={durationFilter}
        />
      </Content>
    </ModalWrapper>
  );
};
